import { render, staticRenderFns } from "./deductaList.vue?vue&type=template&id=ad74fd26&scoped=true"
import script from "./deductaList.vue?vue&type=script&lang=js"
export * from "./deductaList.vue?vue&type=script&lang=js"
import style0 from "./deductaList.vue?vue&type=style&index=0&id=ad74fd26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad74fd26",
  null
  
)

export default component.exports